import React, { useState, useEffect } from "react";
import { GraduationCap, BookOpen } from "lucide-react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import "./ASGConnect2024.css"; 


const images = [
  "images/banners/ags12.jpg", 
  "images/banners/ASG-CONFERENCE.jpg", 
  "images/banners/banner-asg-conference.jpg",
];

const newsData = [
    {
      id: 1,
      image: "images/Executives/Kakra Duffuor-Nyarko FIA FSAG.jpg",
    },
    {
      id: 2,
      image: "images/Executives/Kofi Ntim FSA FASG.jpg",
    },
    {
      id: 3,
      image: "images/Executives/Magnus Owusu-Agyemang AASG.jpg",
    },

  ];

const ASGConnect2024 = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

    const [currentIndex, setCurrentIndex] = useState(0);
  
    // Automatic scrolling every 5 seconds
    useEffect(() => {
      const interval = setInterval(() => {
        nextNews();
      }, 5000);
      return () => clearInterval(interval);
    }, [currentIndex]);
  
    // Next news card
    const nextNews = () => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % newsData.length);
    };
  
    // Previous news card
    const prevNews = () => {
      setCurrentIndex((prevIndex) => (prevIndex - 1 + newsData.length) % newsData.length);
    };
  
    // Slice to show 3 cards
    const visibleNews = [
      newsData[currentIndex],
      newsData[(currentIndex + 1) % newsData.length],
      newsData[(currentIndex + 2) % newsData.length],
    ];
  
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

 

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000); // Change image every 5 seconds
    return () => clearInterval(interval);
  }, []);

  return (
    <div> 
        <section className="section-categories">
        <div className="sectiontop-line"></div>
        <h2 className="sectiontitle">ASG CONFERENCE</h2>
        <div className="sectionbottom-line"></div>
        </section>
    <div className="newscard">
    <div
      className="banner"
      style={{
        backgroundImage: `url(${images[currentImageIndex]})`,
        height: '500px',
        marginBottom: '20px'
      }}
    >
    </div>
    <div className="parag">
        <p>SG offers accreditation leading all 5 exemptions under 
            the Level 1 and 2 of the ASG Pathway specially:v fdfekfa 
            accreditation leading all 5 exemptions under the Level 1 
            and 2 of the ASG Pathway. accreditation leading all 5 exemptions 
            under the Level 1 and 2 of the ASG Pathway.  
        </p>
    </div>
    <section className="card-section" style={{
      display: 'flex',
      flexDirection: 'row',
      alignSelf: 'center',
      margin: '0px',
      justifySelf: 'center',
      justifyContent: 'center',
      alignContent: 'center',
      }}>
      <div className="accreditation-card">
        <GraduationCap className="uni-icon" />
          <h1 className="uni-title">REGISTRATION</h1>
          <p>currently closed...</p>
        </div>

        <div className="accreditation-card">
          <GraduationCap className="uni-icon" />
          <h1 className="uni-title">24 SPEAKERS</h1>
        </div>

        <div className="accreditation-card exemption-card">
          <BookOpen className="uni-icon" />
          <h1 className="uni-title">PROGRAMME</h1>
        </div>
      </section>

      {/*Gallery*/}
      <section className="news-section" style={{
        marginLeft: '85px',
        width: '80%',
        alignSelf: 'center',
        zIndex: '100000',
      }} >
      <h2 className="news-heading">Connect 2024 Gallery</h2>
      <div className="news-carousel">
        <button className="arrow-btn left-arrow" onClick={prevNews}>
          <FaArrowLeft />
        </button>
        <div className="news-cards" style={{ width: '700px', margin: '20px', justifySelf: 'center', alignSelf: 'center' }}>
          {visibleNews.map((news) => (
            <div key={news.id} className="news-card" style={{ height: '300px' }}>
                <img
                  src={news.image}
                  alt={news.title}
                  className="news-image"
                />
            </div>
          ))}
        </div>
        <button className="arrow-btn right-arrow" onClick={nextNews}>
          <FaArrowRight />
        </button>
      </div>
    </section>
    </div>
    </div>

    );
};

export default ASGConnect2024;